export default __webpack_public_path__ + "static/media/mke-zoo-lake-wisconsin.b8c84295.jpg";